"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LayerSettings;

var _react = _interopRequireDefault(require("react"));

var _MultiSelect = _interopRequireDefault(require("../MultiSelect"));

var _settingsUtils = require("./settingsUtils");

var _utils = require("../../utils");

var _slider = require("baseui/slider");

var _checkbox = require("baseui/checkbox");

var _JSUtils = require("../../JSUtils");

var _accordion = require("baseui/accordion");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function LayerSettings(props) {
  var layerName = props.layerName,
      columnNames = props.columnNames,
      onLayerOptionsCallback = props.onLayerOptionsCallback;

  var _React$useState = _react["default"].useState((0, _settingsUtils.getLayerProps)(layerName)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      options = _React$useState2[0],
      setOptions = _React$useState2[1];

  var _React$useState3 = _react["default"].useState({}),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      values = _React$useState4[0],
      setValues = _React$useState4[1];

  _react["default"].useEffect(function () {
    if (!props.layerName) return;
    var lp = (0, _settingsUtils.getLayerProps)(props.layerName);
    if (!lp) return;
    setOptions(lp);
  }, [props.layerName]);

  return _react["default"].createElement(_accordion.Accordion, null, _react["default"].createElement(_accordion.Panel, {
    title: "Settings: " + layerName
  }, Object.keys(options).map(function (key) {
    var v = options[key].type;
    return (0, _JSUtils.isString)(v) && getUIForKey(v, key);
  })));

  function getUIForKey(v, key) {
    if (key === 'class') return null;

    switch (v) {
      case 'number':
        return _react["default"].createElement(_react["default"].Fragment, null, key, _react["default"].createElement(_slider.Slider, {
          value: values[key] && [values[key]] || [options[key]["default"]],
          min: options[key].min,
          max: options[key].max,
          step: options[key].step,
          onChange: function onChange(_ref) {
            var value = _ref.value;

            var newValues = _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, key, value[0]));

            setValues(newValues);
            typeof onLayerOptionsCallback === 'function' && onLayerOptionsCallback(newValues);
          }
        }));

      case 'boolean':
        return _react["default"].createElement(_checkbox.Checkbox, {
          checked: values.hasOwnProperty(key) ? values[key] : options[key].value,
          onChange: function onChange() {
            var newValues = _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, key, !values[key]));

            setValues(newValues);
            typeof onLayerOptionsCallback === 'function' && onLayerOptionsCallback(newValues);
          }
        }, (0, _utils.humanize)(key));

      default:
        return _react["default"].createElement(_react["default"].Fragment, null, key, _react["default"].createElement(_MultiSelect["default"], {
          title: (0, _utils.humanize)(key),
          single: true,
          values: columnNames.map(function (e) {
            return {
              id: (0, _utils.humanize)(e),
              value: e
            };
          }),
          onSelectCallback: function onSelectCallback(selected) {
            var newValues = _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, key, selected.length ? function (d) {
              return d.properties[selected[0].value];
            } : options[key]["default"]));

            setValues(newValues);
            typeof onLayerOptionsCallback === 'function' && onLayerOptionsCallback(newValues);
          }
        }));
    }
  }
}